import React from "react"
import PropTypes from "prop-types"

import Label from "../atoms/Label"

import styles from "./Field.module.css"

const fieldTypes = {
  normal: "normal",
  fieldset: "fieldset",
}

const Field = props => {
  if (props.fieldset) {
    return (
      <fieldset className={styles.container}>
        <Label type="legend">{props.legend}</Label>
        {props.children}
      </fieldset>
    )
  } else {
    return <div className={styles.container}>{props.children}</div>
  }
}

Field.defaultProps = {
  type: fieldTypes.normal,
}

Field.propTypes = {
  legend: PropTypes.string,
  type: PropTypes.oneOf([fieldTypes.normal, fieldTypes.fieldset]),
}

export default Field
